module.exports = __webpack_public_path__ + "static/media/Baby Don't Go.15cfa35e.mp3";